
  import { isTypingInExternalInput } from "@utils/keyboard";

  export default {
    mounted() {
      this._onKeydown = (e) => {
        const isModK =
          (e.metaKey || e.ctrlKey) &&
          !e.altKey &&
          !e.shiftKey &&
          (e.key === "k" || e.key === "K");

        if (!isModK) return;

        // Root users have the admin palette on this page, and ⌘K opens that.
        if (document.getElementById("admin-palette")) return;

        // Don't swallow ⌘K if focus is inside a form field outside the modal
        // (e.g. a topbar search). The in-modal hook also handles its own keys,
        // so we can fire here even when the modal is open — pushing toggles it
        // closed.
        if (isTypingInExternalInput(document.querySelector("[role='dialog']"))) {
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        this.pushEvent("toggle_catalog", {});
      };

      window.addEventListener("keydown", this._onKeydown, true);
    },

    destroyed() {
      window.removeEventListener("keydown", this._onKeydown, true);
    },
  };
